import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/ttl/assets/styles/components/detail-center/comment_report_dialog.scss'

// 请求相关
import { utilsFunction, Converter } from '@/helpers/functions';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, LOADING_TYPE } from "@/constants/app";
import { stockActions } from "@/actions/trading/stock.action";
import { userActions } from '@/actions/user';
import { PARAMS } from '@/constants/params.js'

import RadioOptions from '@/components/TabHeader/RadioOptions';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import Tips from '@/components/Tips/Tips';

class CommentReportDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ReportType: null,
            showOtherInput: false,
            currentOptions: null,
            load: true,
            buttonLoad: false,
            TipsSuccess: false,
            TipsFailure: false,
            showInputNotEmptyTips:false
        }
    }
    render() {
        const { language, style  } = this.props
        const { ReportType, showOtherInput, load, buttonLoad, TipsSuccess, TipsFailure, showInputNotEmptyTips, } = this.state
        return (
            <div className='comment_report_dialog' >
                <LoadingLayer load={load} type={LOADING_TYPE.SKELETON} width={style.width} height={style.height} children={style.loadstyle} ></LoadingLayer>
                {!load && <div>
                    <h3> {language.market_report_reasons} </h3>
                    <div className='report_type' >
                        {<RadioOptions options={ReportType} onChange={(opt) => this.handleSelectRadioType(opt)} />}
                    </div>
                    {showOtherInput && <input placeholder={language.market_comment_other_reason} ref={e => this.inputRef = e}  onChange={() => this.setState({showInputNotEmptyTips:false,TipsFailure:false})}  />}
                    <div className='report_button' >
                        <div className='report_button_cancel' onClick={this.props.onClose} >{language.common_cancel}</div>
                        <div className='report_button_submit' onClick={this.sendReport}>
                            <LoadingLayer load={buttonLoad} type={LOADING_TYPE.SMALL_IMG} ></LoadingLayer>
                            {language.common_submit}
                        </div>
                    </div>
                    <div className='report_tips' >
                        {TipsSuccess && <Tips isSuccess > {language.market_comment_report_success} </Tips>}
                        {TipsFailure && <Tips> {language.market_comment_report_failure} </Tips>}
                        {showInputNotEmptyTips && <Tips> {language.market_comment_input_not_empty} </Tips>}
                    </div>
                </div>}
            </div>
        )
    }
    componentDidMount() {
        this.getReport()
    }
    componentDidUpdate(pre) {
    }
    handleSelectRadioType = (opt) => {
        switch (opt.id) {
            case '19':
                this.setState({ showOtherInput: true , currentOptions: opt.id})
                break;
            default:
                this.setState({ currentOptions: opt.id, showOtherInput: false ,showInputNotEmptyTips:false,TipsFailure:false})
                break
        }
    }
    getReport = () => {
        const { language } = this.props
        this.setState({ load: true })
        let languageParams = ''
        switch (language.key) {
            case 'EN':
                languageParams = 'en'
                break;
            case 'CN':
                languageParams = 'zh-hans'
                break;
            case 'HK':
                languageParams = 'zh-hant'
                break;
        }
        const params = {
            language: languageParams
        }
        this.props.getReportType(params, result => {
            let res = result.result
            let ReportType = []
            if (res) {
                res.forEach((item) => {
                    ReportType.push({ id: item.id, label: item.name, value: item.id })
                })
                this.setState({ ReportType, load: false }, () => {
                    this.setState({ currentOptions: this.state.ReportType[0].id })
                })
            }
        })
    }

    sendReport = () => {
        const { currentOptions } = this.state
        const { nid, getPostList} = this.props
        this.setState({TipsFailure:false,showInputNotEmptyTips:false})
        getPostList()
        const params = {
            type: PARAMS.MARKET_COMMENT_REPORT_POST,  // MARKET_COMMENT_REPORT_COMMENT
            id: nid,  //Content ID.
            spam_value:Number(currentOptions),
            // spam_value: 19,
        }
        if (this.inputRef?.value) params.spam_text = this.inputRef.value
        if (params.spam_value == 19 && !params?.spam_text) {
            this.setState({ showInputNotEmptyTips: true })
        } else {
            this.setState({ buttonLoad: true})
            this.props.sendReport(params, res => {
                if (res) {
                    if ( res.result == 'success' || res.result == 'Cannot repeat reports.' || res.result == '不能重复举报。' || res.result == '不能重複舉報。') {
                        this.setState({ TipsSuccess: true, buttonLoad: false }, () => {
                            setTimeout(() => {
                                this.props.onClose()
                            }, 1000);
                        })
                    } else {
                        this.setState({ TipsFailure: true, buttonLoad: false })
                    }
                }
            })
        }
    }




}

// CommentReportDialog.defaultProps = {
//     ReportType : null
// }



export default connect(state => ({
    language: state.app.language,
}),
    dispatch => ({
        getReportType: (p, c) => dispatch(userActions.getReportTypeAction(p, c)),
        sendReport: (p, c) => dispatch(userActions.getMarketCommentSendReportAction(p, c)),
    }))(CommentReportDialog)
